import axios from 'axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';
import { isEmpty } from 'lodash';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response;
  if (res?.status === 422) dispatch({ type: validationType, validation_error: res.data.errors });
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};


const fetchSuccess = (type, listKey) => data => ({
  type,
  [listKey]: data
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

export const redirectToPostageList = () => ({ type: types.POSTAGE_REDIRECT_TO_LIST });

export const hidePostageValidationError = (feild_key) => ({
  type: types.HIDE_POSTAGE_FIELD_VALIDATION_ERROR,
  feild_key: feild_key
});

// ------- Postage --------
export const fetchPostage = (extraFilters, object_viewed_id = '') => dispatch => {
  dispatch({ type: types.POSTAGE_REQUEST });
  dispatch(loader());

  axios.post(`${API_URL}postage`, 
    {
      object_viewed_id: object_viewed_id,
      ...extraFilters
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
    
  )
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.POSTAGE_SUCCESS, 'postagesList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_VALIDATION_ERROR);
    });
};

// ------- Delete Postage by Month --------
export const deletePostageByMonth = (month, object_viewed_id = '') => (dispatch) => {
  dispatch({ type: types.POSTAGE_REQUEST });
  dispatch(loader());

  axios.delete(`${API_URL}postage/delete`, {
    data: { month, object_viewed_id }, 
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => {
      dispatch(hideLoader());
      dispatch(snackbar(res.data.message || "Postage data deleted successfully", "success"));
      
      // Refresh list after deletion
      dispatch(redirectToPostageList());
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_VALIDATION_ERROR);
    });
};

export const exportPostingByMonth = async (dispatch, month , session) => {

  const token = localStorage.getItem("token");
  const url = `${API_URL}postage/download?month=${month}&object_viewed_id=${session.current_page_permissions.object_id}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    //Handle error JSON responses
    const contentType = response.headers.get("content-type") || "";
    if (!response.ok || contentType.includes("application/json")) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || "Export failed. Please try again.");
    }

    // Always handle ZIP download
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);

    // suggestive filename, fallback if header missing
    const contentDisposition = response.headers.get("content-disposition");
    let filename = "postage_export.zip";
    if (contentDisposition && contentDisposition.includes("filename=")) {
      filename = contentDisposition.split("filename=")[1].replace(/"/g, "");
    }

    // trigger download
    const link = document.createElement("a");
    link.href = urlBlob;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(urlBlob);
  } catch (error) {
    dispatch(snackbar(error.message || "Error exporting file"));
  }
};



// actions/PostageActions.js
export const uploadPostageFile = (formData) => (dispatch) => {
  dispatch({ type: types.POSTAGE_REQUEST });
  dispatch(loader("Uploading postage data..."));

  axios.post(`${API_URL}postage/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((res) => {
      dispatch(hideLoader());
      dispatch(snackbar(res.data.message || "Postage data uploaded successfully", "success"));
      
      //dispatch({ type: types.POSTAGE_UPLOAD_SUCCESS, payload: res.data });
      dispatch(redirectToPostageList());
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_VALIDATION_ERROR);
    });
};

export const fetchAccounts = () => dispatch => {
  dispatch({ type: types.ACCOUNTS_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}accounts`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.ACCOUNTS_SUCCESS, 'accountsList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_VALIDATION_ERROR);
    });
};

// ------- Postage Accounts --------
export const redirectToPostageAccountsList = () => ({
  type: types.POSTAGE_ACCOUNT_REDIRECT_TO_LIST,
});

export const fetchPostageAccounts = (
  extraFilters = {},
  object_viewed_id = ''
) => dispatch => {
  dispatch({ type: types.POSTAGE_ACCOUNTS_REQUEST });
  dispatch(loader());

  axios.post(
    `${API_URL}postage/accounts`,
    {
      object_viewed_id,
      ...extraFilters,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  )
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.POSTAGE_ACCOUNTS_SUCCESS, 'postageAccountsList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_ACCOUNT_VALIDATION_ERROR);
    });
};

export const getPostageAccountById = (
  id,
  actionType = 'update',
  object_viewed_id = ''
) => dispatch => {
  dispatch({ type: types.POSTAGE_ACCOUNTS_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}postage/accounts/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.POSTAGE_ACCOUNT_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_ACCOUNT_VALIDATION_ERROR);
    });
};

export const createOrUpdatePostageAccount = (
  data,
  method = 'PUT',
  object_viewed_id = ''
) => dispatch => {
  dispatch({ type: types.POSTAGE_ACCOUNTS_REQUEST });
  dispatch(loader());

  const id = data?.id;
  const url = id
    ? `${API_URL}postage/accounts/${id}`
    : `${API_URL}postage/accounts`;

  axios({
    url,
    method,
    data: {
      ...data,
      object_viewed_id,
    },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(snackbar(res?.data?.message || 'Postage account updated successfully', 'success'));
      dispatch(redirectToPostageAccountsList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.POSTAGE_ACCOUNT_VALIDATION_ERROR);
    });
};


